<template>
    <div class="mainwrap">
        <div
             class="sliderwrapper"
             id="slwr"
             :style="`transform: translateX(${25 * this.transformfactor}px)`"
        >
            <div  :class="{'tinythumbs':true,'activeindex':activeindex===index}"
                 v-for="(i,index) in images"
                  :style="`background-image: url(${i.src})`"
                 @click="setActiveIndex(i)"
            >

            </div>
<!--            @mouseover="Transform($event,true, index)"-->
<!--            @mousemove="Transform($event, true, index)"-->
<!--            @mouseout="Transform($event,false, index)"-->
        </div>
        <div :style="`left:${left}px;width:${grabberwidth}px;`"
             :class="{'grabber':true,'listening':listening}"
             @mousedown="setStart($event)"
        >
        </div>
    </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props: ['duration', 'poster', 'location'],
    name: "SlideBar",
    components: {},
    data() {
      return {
        barwidth: 0,
        barnet: 0,
        grabberwidth: 30,
        dur: 82,
        listening: false,
        start:0,
        left: 0,
        activeindex: 0,
        images: [],
        slidewrapper: undefined,
        mainwrap: 0,
        rect: undefined,
        transformfactor: 0,
        imageindex: 0,
        ishover: false,
        hotspotcount: 3,
        dhandler: 0
      }
    },
    computed: {
      ...mapState([]),
      setTime() {
        return this.dur
      },
      visibleCount() {
        return parseInt(this.barwidth / 25)
      },
      rightindex() {
        return Math.abs(this.transformfactor) + this.visibleCount
      },
      leftindex() {
        return Math.abs(this.transformfactor)
      },
      maxtransform(){
        return (this.images.length - this.visibleCount) * -1
      },
      percent(){
        return Math.round(this.left/this.barwidth)
      }
    },
    watch:{
      location(n,o){
        let pct = n/this.duration;
        this.left = this.barnet*pct
        this.handleSlide()
      }
    },
    mounted() {
      let em = this;
      document.addEventListener('mousemove', e => {
        if (em.listening === true) {
          em.setLeft(e.movementX)
        }
      })
      document.addEventListener('mouseup', e => {
        em.listening = false
      })
      this.barwidth = document.getElementsByClassName('mainwrap')[0].offsetWidth
      this.barnet = this.barwidth - this.grabberwidth
      this.mainwrap = document.getElementsByClassName('mainwrap')[0]
      this.rect = this.mainwrap.getBoundingClientRect()
      this.sliderwrapper = document.getElementById('slwr')
      this.getImages()
    },
    methods: {
      setLeft(val) { console.log(val)
        this.sliderwrapper.style.transition = 'all .1s ease-in-out';
        if (this.left + val > this.barnet) {
          this.left = this.barnet
        } else if (this.left + val < 0) {
          this.left = 0
        } else {
          this.left += val
        }
        this.handleSlide()
        this.Emit()
      },
      handleSlide(){
        let pct = this.left/this.barnet
        this.activeindex = parseInt(pct*this.images.length)
        this.transformfactor = this.maxtransform*pct + this.visibleCount*.4
      },
      setStart(e) {
        this.barnet = this.barwidth - this.grabberwidth
        this.listening = true;
      },
      setActiveIndex(index){
        this.activeindex = index;
        if(this.barnet===0)this.barnet = this.barwidth - this.grabberwidth
        let pct = index/this.images.length
        console.log(pct)
        this.$emit('location', this.duration*pct)
      },
      Emit(){
        let pct = this.left/this.barnet
        this.$emit('location', this.duration*pct)
      },
      Transform(e, state, i) {
        //transformfactor will be between -? and 0.. max of 0
        this.sliderwrapper.style.transition = 'all 1s ease-in-out';
        this.ishover = state
        if(this.visibleCount>=this.images.length)return
        if (!this.ishover) return;
        if(i===this.images.length)return
        if (this.rightindex-i < Math.abs(this.maxtransform) ){
          if(this.transformfactor<=this.maxtransform){
            return
          } else{
            this.transformfactor--
          }
        } else if(i - this.leftindex > 3){
          if(this.transformfactor>=0){
            return
          } else{
            this.transformfactor++
          }
        }
        // let pct = this.transformfactor/this.maxtransform
        // this.left = this.barnet*pct
      },
      getImages() {
        let d = parseInt(this.duration)
        let ar = [];
        for (let index = 1; index <= d; index++) {
          let c = document.createElement('canvas')
          let ctx = c.getContext('2d')
          c.width=150
          c.height=100
          let p = this.poster.replace('00001.jpg', '')
          let fill = '0000'
          if (index >= 10) {
            fill = '000'
          }
          if (index >= 100) {
            fill = '00'
          }
          if (index >= 1000) {
            fill = '0'
          }
          if (index >= 10000) {
            fill = ''
          }
          let m = new Image(150, 100)
          m.src = p + fill + index + '.jpg'
          ar.push(m)
        }
        this.images = ar
      }
    }
  }

</script>

<style scoped>
    .mainwrap {
        height: 120px;
        position: absolute;
        bottom: 30px;
        z-index: 5;
        display: inline-block;
        width: 100%;
        overflow: hidden;
    }
    .sliderwrapper {
        cursor: pointer;
        height: 25px;
        position: absolute;
        bottom: 25px;
        display: inline;
        white-space: nowrap;
        transition: all .5s ease-in-out;
    }

    .grabber {
        height: 25px;
        cursor: pointer;
        background-color: white;
        position: absolute;
        bottom: 0;
        left: 25px;
        z-index: 6;
        border-radius: 3px;
        user-select: none;
    }

    .tinythumbs {
        height: 25px;
        width: 25px;
        border: solid thin #fff;
        display: inline-block;
        background-position: center;
        background-size: cover;
        transition: all .1s ease-out;
        opacity: .7;
    }

    .tinythumbs:hover, .tinythumbs.activeindex {
        position: relative;
        border-radius: 3px;
        border: none;
        box-shadow: 0 0 0 .2px #ffffff;
        transform: scale(2) translate(0, -6px);
        z-index: 7;
        opacity: 1;
    }


    .listening {
        box-shadow: 0 0 4px 5px #0D47A1;
    }

</style>

